import React from 'react';
import { Button } from 'react-bootstrap';
import back from '../img/back2.png'
import './Screen.css';
import { Link } from 'react-router-dom';
import powerslap from "./video/55.mp4";





function scrollStep() {
  window.scrollBy( { 

    top: 800,
    behavior: 'smooth'

});
}






function Screen() {
  return (

    <div  className="overlay">
<video
  className="viv"
  autoPlay
  loop
  muted
  playsInline
>
  <source src={powerslap} type="video/mp4" />
</video>

   {/* כפתור 1 - כחול קבוע */}
    {/* כפתור 1 - היתרים */}
    <Button 
      onClick={scrollStep} 
      as={Link} 
      to="/Permitforuseexceeds" 
      className="Button" 
      style={{ backgroundColor: '#dc3545', borderColor: '#dc3545'}} 
      size="lg"
    >
        <img className="Buttonback" src={back} alt="" /> 
        <span className="texttitle">&nbsp;היתרים</span>
    </Button>

    {/* כפתור 2 - נגישות */}
    <Button 
      onClick={scrollStep} 
      as={Link} 
      to="/Accessibility" 
      className="Button" 
      style={{ backgroundColor: '#28a745', borderColor: '#28a745'}} 
      size="lg"
    >
        <img className="Buttonback" src={back} alt="" /> 
        <span className="texttitle">&nbsp;נגישות</span>
    </Button>

    {/* כפתור 3 - עסקים */}
    <Button 
      onClick={scrollStep} 
      as={Link} 
      to="/Business" 
      className="Button" 
      style={{ backgroundColor: '#007bff', borderColor: '#007bff'}} 
      size="lg"
    >
        <img className="Buttonback" src={back} alt="" />
        <span className="texttitle">&nbsp;עסקים</span>
    </Button>
    <head>
 <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4942463590341754"
     crossorigin="anonymous"></script>

 </head>

    

 
    </div>



          
 

  )
}

export default Screen;





